<template>
  <div>
    <a-upload
      v-model="fileLink"
      :file-list="fileList"
      :multiple="false"
      :list-type="type"
      :customRequest="customRequest"
      :before-upload="beforeUpload"
      :remove="handleRemove"
    >
      <a-button> <a-icon type="upload" /> 选择文件 </a-button>
    </a-upload>
  </div>
</template>

<script>
import { requestPost } from '@/api/api'

export default {
  name: 'ImgUpload',
  props: {
    url: {
      type: String,
      default: '/upload/pdfs'
    },
    file: {
      type: String,
      default: ''
    },
    // 表单校验用字段
    // eslint-disable-next-line
    value: {
      type: String
    }
  },
  data () {
    return {
      fileLink: '',
      type: 'picture',
      fileList: []
    }
  },
  watch: {
    value (val) {
      console.log(val)
      this.setFileList(val)
    },
    fileLink (val) {
      this.$emit('change', val)
    }
  },
  mounted () {
    const type = this.$props.file
    this.type = type === 'image' ? 'picture' : 'text'
  },
  methods: {
    setFileList (list) {
      if (list) {
        const file = []
        // file.push({ name: this.getString(list, '/storage/image/'), status: 'done', uid: '-1' })
        file.push({ name: list, status: 'done', uid: '-1' })
        this.fileList = file
        this.fileLink = list
      }
    },
    /**
     * 自定义上传图片
     *
     * @files
     */
    customRequest (files) {
      const { file } = files
      const url = this.$props.url
      const formData = new FormData()
      formData.append('file', file)
      requestPost(url, formData)
        .then(res => {
            this.$notification.success({
                message: res.msg
            })
            this.fileLink = res.result
            file.status = 'done'
            this.fileList = [...[], file]
            this.$emit('change', res.result)
        })
        .catch(() => {
          file.status = 'error'
          this.fileList = [...[], file]
        })
    },
    // 上传图片前检测格式及大小
    beforeUpload (file) {
      const isFile = this.handleIsFile(file.name)
      if (!isFile) {
        this.$notification.error({
            message: '请上传正确格式文件!'
        })
        return false
      }
      const isLt100M = file.size / 1024 / 1024 < 100
      if (!isLt100M && isFile === 'img') {
        this.$notification.error({
            message: '文件必须小于100MB!'
        })
        return false
      }
      file.status = 'uploading'

      this.fileList = [...[], file]

      return isFile && isLt100M
    },
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.fileLink = ''
    },
    getString (string, str) {
      // const str1 = string.split(str)[0]
      return string.split(str)[1]
    },
    handleIsFile (str) {
      const file = this.$props.file
      var extension = []

      if (file === 'file') {
        extension = ['pdf', 'xls', 'xlsv', 'csv', 'docx', 'doc', 'csv', 'zip']
      } else if (file === 'zip') {
        extension = ['zip']
      } else if (file === 'video') {
        extension = ['mp4', '3gp', 'rmvb']
      } else if (file === 'import') {
        extension = ['xls', 'xlsv', 'csv', 'xlsx']
      } else if (file === 'image') {
        extension = ['jpg', 'jpeg', 'png']
      }
      const type = this.getString(str, '.')
      // console.log(type, extension.indexOf(type), extension.indexOf(type) !== -1)
      return file ? extension.indexOf(type) !== -1 : true
    }
  }
}
</script>

<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload.ant-upload-select-picture-card > .ant-upload {
  padding: 0;
}
.avatar-uploader > .ant-upload img {
  max-width: 128px;
  max-height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
